import { render } from "./DivisionTable.vue?vue&type=template&id=24e1bb15"
import script from "./DivisionTable.vue?vue&type=script&lang=js"
export * from "./DivisionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__